import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal, Form } from 'react-bootstrap';
import styles from './styles.css';
import messages from './messages';

const ModalForm = ({
  handleSubmit,
  show,
  onHide,
  children,
  title,
  submitLabel,
  cancelLabel,
}) => {
  const handleCancel = (e) => {
    e.preventDefault();
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton >
        <h1 className={styles['modal-title']}>
          {title}
        </h1>
      </Modal.Header>
      <div className={styles['modal-body']}>
        <Form onSubmit={handleSubmit} className={styles['modal-body']}>
          {children}
          <div className={styles.buttonWrapper}>
            <button onClick={handleCancel} className="btn-offset-left buttons buttons-gray" >
              {cancelLabel}
            </button>
            <button type="submit" className="btn-offset-left buttons buttons-primary" >
              {submitLabel}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};


ModalForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  submitLabel: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  cancelLabel: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

ModalForm.defaultProps = {
  children: [],
  title: '',
  submitLabel: <FormattedMessage {...messages.submit} />,
  cancelLabel: <FormattedMessage {...messages.cancel} />,
};

export default ModalForm;



// WEBPACK FOOTER //
// ./src/components/ModalForm/index.js